"use client";

import {
  deleteAddressDropsip,
  getAddressDropsip,
} from "@/functions/databaseData";
import useAlert from "@/functions/useAlert";
import {
  ArrowDownSvg,
  ArrowUpSvg,
  DeleteSolidSvg,
  PlusOutlineSvg,
  SearchSvg,
} from "@/public/svg";
import { useRouter } from "next/navigation";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { FooterTable } from "../../_component";
import Input from "@/components/atom/Input";
import Button from "@/components/atom/Button";
import useHeader from "@/functions/useHeader";

export default function CustomerSaya() {
  const { session } = useHeader();
  const { showAlert } = useAlert();
  const router = useRouter();
  const [dataModal, setDataModal] = useState({
    user: {},
    dataDiscount: [],
  });
  const [myCustomer, setMyCustomer] = useState([]);
  const [search, setSearch] = useState("");
  const headList = [
    "No.",
    "Nama",
    "Telp",
    "Detail Alamat",
    "Kelurahan",
    "Kecamatan",
    "Kota/Kabupaten",
    "Provinsi",
    "Aksi",
  ];

  function handleDeleteCustomer(item) {
    async function runDetelete(item) {
      try {
        const res = await deleteAddressDropsip({
          id: item?.id_doc,
          token: session?.user?.token,
        });
        if (!res.error) {
          return runGetDropsip();
        }
        console.log(error.message);
      } catch (error) {
        console.log(error.message);
      }
    }

    const msg = () => (
      <p>
        Apakah Anda yakin akan menghapus alamat{" "}
        <strong className='capitalize'>{item?.recipets_name}</strong> dari
        daftar?
      </p>
    );

    showAlert({
      error: true,
      versiAlert: 2,
      title: "Konfirmasi Hapus",
      desc: () => msg(),
      handleClick: {
        open: {
          onClick: () => runDetelete(item),
          text: "Ya, Hapus Alamat",
          hide: false,
          colors: "error",
        },
        close: {
          onClick: () => {},
          text: "Tidak, Batalkan",
          hide: false,
          colors: "error",
        },
      },
    });
  }

  useEffect(() => {
    runGetDropsip();
  }, [dataModal?.user]);

  const runGetDropsip = useCallback(async () => {
    try {
      const res = await getAddressDropsip({
        id: session?.user?.data?.mitra_id,
        token: session?.user?.token,
      });
      setMyCustomer(res?.reverse());
    } catch (error) {
      console.log(error.message);
    }
  }, [session?.user]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [trigger, setTrigger] = useState(false);

  function runSorted(item) {
    const valueSort =
      item == "Nama"
        ? "recipets_name"
        : item == "Kelurahan"
        ? "subdistrict_name"
        : item == "Kecamatan"
        ? "district_name"
        : item == "Kota/Kabupaten"
        ? "city_name"
        : "province_name";

    let data = myCustomer;
    if (trigger?.[item]) {
      data = data.sort((a, b) => b?.[valueSort].localeCompare(a?.[valueSort]));
      setTrigger((old) => ({ ...old, [item]: false }));
    } else {
      data = data.sort((a, b) => a?.[valueSort].localeCompare(b?.[valueSort]));
      setTrigger((old) => ({ ...old, [item]: true }));
    }
    setMyCustomer(data);
  }
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const isMyCustomer = myCustomer?.filter((item) => {
      return search?.length > 0
        ? item?.recipets_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
            item?.address?.toLowerCase()?.includes(search?.toLowerCase()) ||
            item?.province_name
              ?.toLowerCase()
              ?.includes(search?.toLowerCase()) ||
            item?.city_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
            item?.district_name
              ?.toLowerCase()
              ?.includes(search?.toLowerCase()) ||
            item?.subdistrict_name
              ?.toLowerCase()
              ?.includes(search?.toLowerCase()) ||
            item?.postal_code?.toLowerCase()?.includes(search?.toLowerCase()) ||
            item?.telephone?.toLowerCase()?.includes(search?.toLowerCase())
        : item;
    });
    return isMyCustomer?.slice(firstPageIndex, lastPageIndex);
  }, [pageSize, currentPage, myCustomer, search, trigger]);

  const listSorted = [
    "Nama",
    "Kelurahan",
    "Kecamatan",
    "Kota/Kabupaten",
    "Provinsi",
  ];

  return (
    <React.Fragment>
      <div className='flex flex-col gap-4 xs:gap-8'>
        <div className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8'>
          <div className='flex flex-col-reverse xs:flex-row justify-between gap-4 items-center'>
            <div className='flex items-center gap-4 w-full'>
              <Input
                icon={{
                  left: (props) => <SearchSvg {...props} />,
                }}
                placeholder='Cari berdasarkan nama, nomor Hp atau wilayah'
                onChange={(val) => setSearch(val)}
                value={search}
                onSubmit={(e) => e.preventDefault()}
                // onKeyDown={() => router.push(`/search/${valueSearch}`)}
                enterKeyHint={"search"}
              />
              <Button
                label='Cari'
                variants='outline'
                className='hidden xs:block'
              />
            </div>
            <div className='flex w-full justify-end'>
              <Button
                className='flex w-full xs:w-auto'
                label='Tambah'
                variants='solid'
                onClick={() =>
                  router?.push(
                    session?.user?.data?.mitra_level < 5
                      ? "customer-saya/tambah-customer"
                      : "daftar-alamat/tambah-alamat"
                  )
                }
                icon={{
                  left: (props) => <PlusOutlineSvg {...props} />,
                }}
              />
            </div>
          </div>
        </div>
        <div className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 overflow-hidden overflow-x-scroll'>
          <table className='table-auto w-full'>
            <thead>
              <tr>
                {headList?.map((item, index) => (
                  <th
                    key={index}
                    // className={twMerge("p-4", index === 0 ? "w-32" : " w-32")}
                    className={twMerge(
                      "pb-4 border-b-[1px] border-greyscaleGON-200",
                      listSorted?.find((val) => val == item) && "cursor-pointer"
                    )}
                    onClick={() => runSorted(item)}>
                    <div className='flex items-center gap-1'>
                      <p className='capitalize text-start p2-medium text-greyscaleGON-700 max-w-full whitespace-nowrap overflow-hidden text-ellipsis'>
                        {item}
                      </p>
                      {listSorted?.find((val) => val == item) && (
                        <>
                          {trigger?.[item] ? (
                            <ArrowUpSvg className='h-4 w-4 text-greyscaleGON-700' />
                          ) : (
                            <ArrowDownSvg className='h-4 w-4 text-greyscaleGON-700' />
                          )}
                        </>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='bg-shadesGON-50'>
              {currentTableData?.map((item, index) => (
                <tr key={(currentPage - 1) * pageSize + (index + 1)}>
                  <td className='pt-4 pr-4'>
                    {(currentPage - 1) * pageSize + (index + 1)}.
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                      {item?.recipets_name}
                    </p>
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                      {item?.telephone}
                    </p>
                  </td>
                  <td className={twMerge("pt-4 pr-4 group")}>
                    <div className='relative w-fit '>
                      <div className='group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all'>
                        <span
                          className={twMerge(
                            item?.address?.length < 20 ? "hidden" : "absolute",
                            " bg-neutral-500 text-white rounded-md min-w-[20rem]",
                            "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                            "z-50",
                            "capitalize p3-medium text-shadesGON-50 px-2 py-1"
                          )}>
                          {item?.address}
                        </span>
                        <span className='absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500' />
                      </div>
                      <p className='whitespace-nowrap capitalize p1-regular text-greyscaleGON-700'>
                        {item?.address?.length < 20
                          ? item?.address
                          : `${item?.address?.slice(0, 20)}...`}
                      </p>
                    </div>
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                      {item?.subdistrict_name}
                    </p>
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                      {item?.district_name}
                    </p>
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                      {item?.city_name}
                    </p>
                  </td>
                  <td className='pt-4 pr-4'>
                    <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                      {item?.province_name}
                    </p>
                  </td>
                  <td className='flex gap-2 items-center pt-4 pr-4'>
                    <div
                      onClick={() => handleDeleteCustomer(item)}
                      className='cursor-pointer relative group'>
                      <DeleteSolidSvg className='text-errorGON-400 w-6 h-6 xs:w-7 xs:h-7' />
                      <div className='group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all'>
                        <span
                          className={twMerge(
                            "absolute inline-block bg-neutral-500 text-white rounded-md",
                            "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                            "z-50",
                            "whitespace-nowrap capitalize p3-medium text-shadesGON-50 px-2 py-1"
                          )}>
                          Delete
                        </span>
                        <span className='absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500' />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <FooterTable
            currentPage={currentPage}
            totalCount={myCustomer?.length}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
